import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { outdateOperations } from '../store/hfs-operations/reducer';

const useHfsOperationsTimeoutController = () => {
  const [timeoutRef, setTimeoutRef] = useState<NodeJS.Timeout | null>(null);
  const dispatch = useDispatch();
  useEffect(() => {
    setTimeoutRef(setInterval(() => dispatch(outdateOperations()), 15_000));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (timeoutRef) {
        clearInterval(timeoutRef);
      }
    };
  }, [dispatch, timeoutRef]);
};

export { useHfsOperationsTimeoutController };
